import React, { useCallback, useMemo } from 'react'
import useParams from 'core/hooks/useParams'
import ModalForm from 'core/elements/modal/ModalForm'
import { updateVolumeMetadata } from './actions'
import useUpdateAction from 'core/hooks/useUpdateAction'
import KeyValuesField from 'core/components/validatedForm/KeyValuesField'

export default function EditVolumeMetadataModal({ rows: volumes, onClose }) {
  const volume = volumes?.[0]
  const defaultParams = useMemo(
    () => ({
      metadata: Object.entries(volume.metadata).map(([key, value]) => {
        return { key, value }
      }),
    }),
    [volume.metadata],
  )

  const { params, getParamsUpdater, updateParams, setParams } = useParams<{
    metadata: any
  }>(defaultParams)

  const { update, updating, error, reset } = useUpdateAction(updateVolumeMetadata)

  const handleClose = () => {
    setParams(defaultParams)
    reset()
    onClose(true)
  }

  const submitForm = useCallback(async () => {
    const metadata = params.metadata.reduce((accum, pair) => {
      return {
        ...accum,
        [pair.key]: pair.value,
      }
    }, {})
    const body = {
      metadata,
    }
    const { success } = await update({
      id: volume.id,
      body,
    })
    if (success) {
      handleClose()
    }
  }, [volume, params, handleClose])

  return (
    <ModalForm
      open
      title={`Edit Volume Metadata`}
      onSubmit={submitForm}
      onClose={handleClose}
      submitting={updating}
      error={error}
      submitTitle={`Update Metadata`}
      loading={false}
    >
      <KeyValuesField
        id="metadata"
        label="Metadata"
        value={params.metadata}
        onChange={getParamsUpdater('metadata')}
        addLabel="Add Metadata"
        allowMultipleValues
      />
    </ModalForm>
  )
}
